import React from "react";
import "../css/CampusSection.css";
import { Link } from "react-router-dom";
const CampusSection = () => {
  return (
    <section className="campus-section">
      <div className="campus-container">
        {}
        <div className="campus-content">
          <h2>NEXTGEN CAMPUS IN SAHARA</h2>
          <p>
            Sahara Public School operates with a clear vision to offer high
            standards of education, which can only be achieved through
            continuous innovation to meet the learning needs of students. As a
            top-rated school, we offer world-class amenities, state-of-the-art
            technologies, and well-designed learning zones. Our next-generation
            campus is fully integrated with smart classrooms and interactive
            labs that transform everyday learning into an engaging, hands-on
            experience. We empower our students to think critically and prepare
            them to confidently navigate the digital future.
          </p>
          <a href="#" className="btn btn-primary">
            <Link to="/about" >VIEW ALL</Link> <span>→</span>
          </a>
        </div>

        {}
        <div className="campus-image">
          <img src="../images/campus.jpg" alt="Sahara Campus" />
          <div className="image-label">Sahara Campus</div>
        </div>
      </div>
    </section>
  );
};

export default CampusSection;
